// Runtime API URL detection
// If REACT_APP_API_URL is set, use it
// Otherwise, check if we're on localhost at runtime
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Runtime check: if hostname is localhost, use local server
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:5001';
  }

  // Otherwise, use same domain (for Vercel production)
  return '';
};

const API_URL = getApiUrl();

export default API_URL;